import { baseApi } from './baseApi';
import {
  Supplier,
  CreateSupplierRequest,
  UpdateSupplierRequest,
  SupplierItem,
  CreateSupplierItemRequest,
  UpdateSupplierItemRequest,
} from '../types/inventory';

export const suppliersApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getSuppliers: builder.query<Supplier[], void>({
      query: () => '/suppliers',
      providesTags: ['Supplier'],
    }),
    getSupplier: builder.query<Supplier, string>({
      query: (id) => `/suppliers/${id}`,
      providesTags: (_result, _error, id) => [{ type: 'Supplier', id }],
    }),
    createSupplier: builder.mutation<Supplier, CreateSupplierRequest>({
      query: (data) => ({ url: '/suppliers', method: 'POST', body: data }),
      invalidatesTags: ['Supplier'],
    }),
    updateSupplier: builder.mutation<Supplier, { id: string; data: UpdateSupplierRequest }>({
      query: ({ id, data }) => ({ url: `/suppliers/${id}`, method: 'PUT', body: data }),
      invalidatesTags: ['Supplier'],
    }),
    deleteSupplier: builder.mutation<void, string>({
      query: (id) => ({ url: `/suppliers/${id}`, method: 'DELETE' }),
      invalidatesTags: ['Supplier'],
    }),

    // Supplier Items
    getSupplierItems: builder.query<SupplierItem[], string>({
      query: (supplierId) => `/suppliers/${supplierId}/items`,
      providesTags: ['Supplier'],
    }),
    createSupplierItem: builder.mutation<SupplierItem, CreateSupplierItemRequest>({
      query: (data) => ({ url: '/suppliers/items', method: 'POST', body: data }),
      invalidatesTags: ['Supplier'],
    }),
    updateSupplierItem: builder.mutation<SupplierItem, { id: string; data: UpdateSupplierItemRequest }>({
      query: ({ id, data }) => ({ url: `/suppliers/items/${id}`, method: 'PUT', body: data }),
      invalidatesTags: ['Supplier'],
    }),
    deleteSupplierItem: builder.mutation<void, string>({
      query: (id) => ({ url: `/suppliers/items/${id}`, method: 'DELETE' }),
      invalidatesTags: ['Supplier'],
    }),
    getSuppliersByItem: builder.query<SupplierItem[], string>({
      query: (inventoryItemId) => `/suppliers/by-item/${inventoryItemId}`,
      providesTags: ['Supplier'],
    }),
  }),
});

export const {
  useGetSuppliersQuery,
  useGetSupplierQuery,
  useCreateSupplierMutation,
  useUpdateSupplierMutation,
  useDeleteSupplierMutation,
  useGetSupplierItemsQuery,
  useCreateSupplierItemMutation,
  useUpdateSupplierItemMutation,
  useDeleteSupplierItemMutation,
  useGetSuppliersByItemQuery,
} = suppliersApi;
